const isRunningOnClient: boolean = typeof window !== 'undefined' && !!window.document;

export default isRunningOnClient;
